import metchIdIcon from 'modules/common/icons/match-id-icon.png';
import { useGlobalTranslation } from 'modules/i18n';

import { ConnectButton } from '../ConnectButton';
import { useStyles } from './useStyles';

export interface EthereumButtonProps {
  isDisabled?: boolean;
  onClick: () => void;
}

export function MatchIdButton({ isDisabled, onClick }: EthereumButtonProps) {
  const { classes } = useStyles();
  const { t, keys } = useGlobalTranslation();

  return (
    <ConnectButton
      fullWidth
      className={classes.button}
      disabled={isDisabled}
      startIcon={
        <div className={classes.icon}>
          <img alt="" src={metchIdIcon} />
        </div>
      }
      onClick={onClick}
    >
      {t(keys.common.matchIDWallet)}
    </ConnectButton>
  );
}
